var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"panel-heading has-text-centered"},[_c('p',[_vm._v(_vm._s(_vm.title))]),(_vm.showClose)?_c('span',{staticClass:"close-button",on:{"click":_vm.close}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }